import { useEffect } from "react";

const TermAndCondition = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <section>{/* <Navbar /> */}</section>
      <section>
        <div className="tnc_container">
          <div className="tnc_wraper">
            <h1>Terms & Conditions</h1>
            <p>for Owision AB</p>
          </div>
        </div>
      </section>
      <section></section>
    </>
  );
};

export default TermAndCondition;
